<div class="user-heading-section d-flex justify-content-between align-items-center">
    <h2 class="m-0 font-size-22">User management</h2>
    <div class="d-flex cursor-pointer" style="gap: 8px;" (click)="downloadUserList()">
        <img src="/assets/admin-images/download_icon.png" alt="download" style="height: 20px;"/>
        <p class="m-0 font-size-16 font-weight-700" style="color: #503291;">Download</p>
    </div>
</div>
<div class="user-mgmt-container">
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center w-100" style="gap: 40px;">
            <div style="width: 15%; margin-top: 14px; margin-bottom: 14px;">
                <ng-multiselect-dropdown [placeholder]="'Role'" [settings]="dropdownSettings" [data]="roleDropdownList"
                    [(ngModel)]="selectedRoleItems" (ngModelChange)="onRoleItemSelect($event)">
                </ng-multiselect-dropdown>
            </div>
            <div style="width: 15%; margin-top: 14px; margin-bottom: 14px;">
                <ng-multiselect-dropdown [placeholder]="'Category'" [settings]="dropdownSettings"
                    [data]="categoryDropdownList" [(ngModel)]="selectedCategoryItems"
                    (ngModelChange)="onCategoryItemSelect($event)">
                </ng-multiselect-dropdown>
            </div>
            <div style="width: 15%; margin-top: 14px; margin-bottom: 14px;">
                <ng-multiselect-dropdown [placeholder]="'Status'" [settings]="dropdownSettings"
                    [data]="statusDropdownList" [(ngModel)]="selectedStatusItems"
                    (ngModelChange)="onStatusItemSelect($event)">
                </ng-multiselect-dropdown>
            </div>
        </div>

        <div class="position-relative search-input-box">
          
            <input type="text" placeholder="Search" class="p-8 search-input" style="width: 94%; font-size: 14px;" [(ngModel)]="searchtextData" (ngModelChange)="onSearchChange()" #searchInput>
            <div class="position-absolute search-icon cursor-pointer">
                <div class="d-flex align-items-center" style="gap: 8px;">
                    <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search" (click)="clearSearch()" *ngIf="searchtextData">
                    <span style="color: #E1E1EA;" *ngIf="searchtextData">|</span>
                    <img src="/assets/icons/Group 57082.svg" alt="search" (click)="searchData(searchtextData)">
                </div>
            </div>
        </div>
    </div>

    <mat-card class="user-mgmt-card-table-container">
        <table mat-table [dataSource]="dataSource" *ngIf="allUsersList?.length > 0" aria-label="List of all users">

            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;">
                    <mat-checkbox (change)="toggleAllRows()"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleRowSelection(row)"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- username Column with sorting -->
            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 20%;"> <span style="margin-right: 10px;">Username</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('usernameSort')" *ngIf="userNameAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('usernameSort')" *ngIf="userNameDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!userNameAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!userNameDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let element"> 
                    <div style="font-weight: 700;">{{element?.username}}</div>
                    <div style="font-size: 12px; color: #091734;">{{element?.email}}</div>
                </td>
            </ng-container>

            <!-- role Column with sorting -->
            <ng-container matColumnDef="role_name">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 10%;"> <span style="margin-right: 10px;">Role</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('roleSort')" *ngIf="roleAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('roleSort')" *ngIf="roleDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!roleAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!roleDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let element" style="color: #091734;"> {{element.role_name}} </td>
            </ng-container>

            <!-- category Column with sorting -->
            <ng-container matColumnDef="category_names_str">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 20%;"><span style="margin-right: 10px;">Category</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('catSort')" *ngIf="catAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('catSort')" *ngIf="catDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!catAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!catDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let element" style="color: #091734;"> <span *ngIf="element?.category_names.length" style="word-break: break-all;">{{element?.category_names[0]}}</span> <span style="background-color: #5E5E72;color: #FFFFFF; padding: 6px; border-radius: 11px; font-weight: 700; margin-left: 4px;" class="see-more cursor-pointer" *ngIf="element.category_names.length > 1" matTooltip = "{{getRemainingCategories(element.category_names)}}">+{{element?.category_names.length - 1}}</span>
                <span *ngIf="!element?.category_names.length">-</span></td>
            </ng-container>

            <!-- last user login Column with sorting -->
            <ng-container matColumnDef="last_login">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 20%;"> <span style="margin-right: 10px;">Last Used</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('lastLoginSort')" *ngIf="lastLoginAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('lastLoginSort')" *ngIf="lastLoginDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!lastLoginAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!lastLoginDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let element" style="color: #091734;"> {{element.last_login | dateWithTimeFormatter}} </td>
            </ng-container>

            <!-- status Column with sorting -->
            <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 10%;"><span style="margin-right: 10px;">Status</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('statusSort')" *ngIf="statusAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('statusSort')" *ngIf="statusDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!statusAscSort"/></span>
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!statusDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let element">
                    <p *ngIf="element.active" style="padding: 6px; border-radius: 6px; background-color: #01884C; font-weight: 700; color: #FFFFFF; width: fit-content; margin: 0px;">Active</p>
                    <p *ngIf="!element.active" style="padding: 6px; border-radius: 6px; background-color: #E61E50; font-weight: 700; color: #FFFFFF; width: fit-content; margin: 0px;">Inactive</p>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef style="text-align: end; width: 10%;"> Actions </th>
                <td mat-cell *matCellDef="let user">
                    <div class="d-flex align-items-center justify-content-end" style="gap: 16px;">
                        <img src="/assets/admin-images/user_active_inactive_icon.png" alt="user_active_inactive"
                            style="height: 20px;" class="cursor-pointer" [ngClass]="{'disabled-icon': isPopupVisible}" (click)="activeDeactiveRowSelection(user,$event)" *ngIf="user.active" title="Deactivate"/>
                        <img src="/assets/admin-images/user_active_icon.png" alt="user_active_inactive"
                            style="height: 20px;" class="cursor-pointer" [ngClass]="{'disabled-icon': isPopupVisible}" (click)="activeDeactiveRowSelection(user,$event)" *ngIf="!user.active" title="Activate"/>
                        <img src="/assets/admin-images/pen_icon.png" alt="edit" style="height: 20px;"
                            class="cursor-pointer" [ngClass]="{'disabled-icon': isPopupVisible}" (click)="editRowSelection(user,$event)" title="Edit"/>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
        <div *ngIf="allUsersList?.length <= 0" style="margin: 30px; font-size: 24px; font-weight: 700; text-align: center;">
            No records found.
        </div>

       
        <div class="pagination-container" *ngIf="allUsersList?.length > 0">
            <mat-paginator #paginator
                [length]="totalRecords"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="pageSizeOptions"
                (page)="onPageChange($event)">
            </mat-paginator>
            
            <!-- Custom Page Dropdown -->
            <div class="page-dropdown">
                <mat-select [(ngModel)]="pageIndex" (selectionChange)="onPageChangeFromDropdown($event)">
                    <mat-option *ngFor="let page of pageNumbers" [value]="page" style="font-family: 'Lato', sans-serif;">{{ page + 1 }}</mat-option>
                </mat-select>
            </div>
            <p style="position: absolute; right: 115px; top: 5px; font-size: 14px; font-weight: 700; color: #1B1B25;">{{pageIndex +1}} of {{pageNumbers.length}} pages</p>
        </div>
    </mat-card>

    <div *ngIf="isPopupVisible" style="position: fixed; background-color: #454554; color: #FFFFFF; padding: 17px; max-width: 474px; width: 100%; left: 0; right: 0; margin: auto; bottom: 30px; border-radius: 8px;">
       
         <div>
            <div class="d-flex align-items-center">
                <p class="m-0 mr-16" style="font-size: 16px; font-weight: 400; color: #ECECF4;" *ngIf="selection.selected.length">{{selection.selected.length}} Selected</p>
                <p class="m-0 mr-16" style="color: #ECECF4;">|</p>
                <p class="m-0 mr-16 cursor-pointer" style="font-size: 14px; font-weight: 700; margin-top: 2px;" (click)="selectAllUsers()"><span *ngIf="!isAllSelected()">Select All</span><span *ngIf="isAllSelected()">Unselect All</span></p>
                <p class="m-0 mr-16" style="color: #ECECF4;">|</p>
                <p class="m-0 mr-16 cursor-pointer" style="font-size: 14px; font-weight: 700; margin-top: 2px;" (click)="changeRole()">Change Role</p>
                <p class="m-0 mr-16" style="color: #ECECF4;">|</p>
                <p class="m-0 mr-16 cursor-pointer" style="font-size: 14px; font-weight: 700; margin-top: 2px;" (click)="changeStatus()">Change Status</p>
                <img src="assets/admin-images/cross_white_icon.png" alt="cancel" style="height: 20px; margin-top: 2px;" (click)="closeFloatingDialog()" class="cursor-pointer"/>
            </div>
        </div>
    </div>

</div>
@if(isLoading){
    <app-loader></app-loader>
}